module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.message) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.openNotificationWithType(_vm.message.type, _vm.message.title, _vm.message.message, _vm.message.duration)) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71a4d2ec"}!./client/components/helpers/message/template.html
// module id = 228
// module chunks = 17